import { render } from "./MainNavbarPages.vue?vue&type=template&id=0dba4b12&scoped=true"
import script from "./MainNavbarPages.vue?vue&type=script&lang=js"
export * from "./MainNavbarPages.vue?vue&type=script&lang=js"

import "./MainNavbarPages.vue?vue&type=style&index=0&id=0dba4b12&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0dba4b12"]])

export default __exports__